var _excluded = ["item", "disabled"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * Used by internal Dropdown hooks to handle the return value of useDisabledItems.
 * Wrapper for getItemProps which checks for the "disabled" property on the given item.
 * This property is added by the useDisabledItems hook.
 * If the item's "disabled" prop is provided it will set the "disabled" for getItemProps.
 * This prevents selection of disabled items.
 * @param getItemProps prop getter returned from downshift hook
 * @returns modified version of getItemProps
 */
export var useGetItemProps = function useGetItemProps(_ref) {
  var getItemProps = _ref.getItemProps;
  return function (_ref2) {
    var item = _ref2.item,
        disabled = _ref2.disabled,
        rest = _objectWithoutProperties(_ref2, _excluded);

    return getItemProps(_objectSpread({
      item: item,
      disabled: disabled !== undefined ? disabled : item.disabled
    }, rest));
  };
};
/**
 * A hook used to manage all logic needed for disabled menu items.  This hook is not
 * required if you add a "disabled" property to your disabled items.  If you are also
 * using useGroupedItems, useDisabledItems must come after and accept its returned "items".
 */

export default (function (_ref3) {
  var items = _ref3.items,
      isItemDisabled = _ref3.isItemDisabled;

  for (var i = 0; i < items.length; i++) {
    if (items[i].disabled) {
      continue;
    }

    if (isItemDisabled(items[i], i)) {
      items[i].disabled = true;
    }
  }

  return {
    items: items
  };
});
//# sourceMappingURL=useDisabledItems.js.map